import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ChildId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ChildId {
    return new ChildId(value);
  }
}
